import hasCloudflareBeaconFrame from './hasCloudflareBeaconFrame'
import isExtensionFetchFailure from './isExtensionFetchFailure'
import isExtensionMessagingError from './isExtensionMessagingError'
import isInjectedBridgeError from './isInjectedBridgeError'
import isInjectedErrorHandlerError from './isInjectedErrorHandlerError'
import isInjectedUserScriptError from './isInjectedUserScriptError'
import isThirdPartyOnly from './isThirdPartyOnly'


// A Sentry `beforeSend` hook that discards events originating entirely in
// third-party code (analytics, chat widgets, browser extensions, etc.) loaded
// alongside our app. `isThirdPartyOnly` makes that call by frame origin and
// catches most of them; every predicate ahead of it names a case that slips past
// the origin check, because the third-party code either ran inline, or was served
// from our origin, or was given no URL at all.
//
// Returning null discards the event; returning the event keeps it.
//
export default function dropThirdPartyEvents(event) {
  if ( isInjectedUserScriptError(event) ) {
    return null
  }

  const values = event?.exception?.values || []

  if ( isInjectedBridgeError(values) ) {
    return null
  }

  if ( isExtensionMessagingError(values) ) {
    return null
  }

  if ( isInjectedErrorHandlerError(values) ) {
    return null
  }

  const frames = values.flatMap(({ stacktrace }) => stacktrace?.frames || [])

  if ( isExtensionFetchFailure({ frames, values }) ) {
    return null
  }

  if ( hasCloudflareBeaconFrame(frames) ) {
    return null
  }

  if ( isThirdPartyOnly(frames) ) {
    return null
  }

  return event
}
